import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'po/'

const initialState = {
    masterData: [],
    PODetails: [],
    draftPR: [],
    isLoading: false,
    returnPONo: "",
    addEDLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getDraftPR = createAsyncThunk('PO/gdpr', async (_, thunkAPI) => {

    try {
        const result = await axios.get(API_URL + 'getDraftPR')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getPRDetails = createAsyncThunk('PO/gdprd', async (prID, thunkAPI) => {

    try {
        const result = await axios.get(API_URL + `getPRDetails/${prID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getPOMasterData = createAsyncThunk('PO/gaPR', async (_, thunkAPI) => {

    try {
        const result = await axios.get(API_URL)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getPOData = createAsyncThunk('PO/gvd', async (prID, thunkAPI) => {
    try {
        const result = await axios.get(`${API_URL}getPOData/${prID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const completePO = createAsyncThunk('PO/complete', async (poID, thunkAPI) => {
    try {
        const result = await axios.patch(API_URL + `${poID}/complete`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const createPOMaster = createAsyncThunk('PO/avmd', async (vData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL, vData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const createPODetail = createAsyncThunk('PO/avdd', async (poDetailData, thunkAPI) => {
    try {

        const result = await axios.post(API_URL + 'detail/', poDetailData)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const getSingleItem = createAsyncThunk('PO/gsi', async (RONO, thunkAPI) => {
    try {

        const result = await axios.get(API_URL + `detail/${RONO}`)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const updateSingleItem = createAsyncThunk('PO/usi', async (edData, thunkAPI) => {
    try {

        const result = await axios.put(API_URL + `detail/${edData.RONO}`, edData)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const deleteItem = createAsyncThunk('PO/usi', async (edData, thunkAPI) => {
    try {

        const result = await axios.put(API_URL + `detail/${edData.RONO}`, edData)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const poSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.masterData = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getDraftPR.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getDraftPR.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.draftPR = action.payload
            })
            .addCase(getDraftPR.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getPOMasterData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getPOMasterData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(getPOMasterData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(createPOMaster.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createPOMaster.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.returnPONo = action.payload
            })
            .addCase(createPOMaster.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload.PONo
            })
            .addCase(getPOData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getPOData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.PODetails = action.payload.pd
            })
            .addCase(getPOData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(createPODetail.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createPODetail.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.PODetails = action.payload
            })
            .addCase(createPODetail.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(updateSingleItem.pending, (state) => {
                state.isLoading = true
            })
            .addCase(updateSingleItem.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.PODetails = action.payload
            })
            .addCase(updateSingleItem.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = poSlice.actions

export default poSlice.reducer
